import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeService } from 'src/app/services/employee.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccessLevels } from 'src/app/models/access_levels';
import { StationService } from 'src/app/services/station.service';
import { AgentScheduleService } from 'src/app/services/agent-schedule.service';
import { AgentSlotsCalenderComponent } from '../agent-slots-calender/agent-slots-calender.component';
import { BsModalService } from 'ngx-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-outsourced-agency',
  templateUrl: './outsourced-agency.component.html',
  styleUrls: ['./outsourced-agency.component.scss']
})
export class OutsourcedAgencyComponent implements OnInit {
  formTitle = 'Add Outsourced Agency'
  allOusourcedEmployees;
  stationsList;
  activePage
  searchText;
  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private notifier: NotifierService,
    private employeeService: EmployeeService,
    private authService: AuthenticationService,
    private stationService: StationService,
    private agentScheduleService: AgentScheduleService) {
    this.getData()

  }

  getData() {
    this.searchText = ''
    this.spinner.show();
    if (this.authService.getAccessLevel() == AccessLevels.superAdmin) {
      this.getAllStations();
      this.getEmployees();
    } else {
      this.employeeService.getEmployeeById(this.authService.getCurrentUserId()).subscribe(res => {
        this.stationsList = res['result']['stations']
        this.getEmployeesByStationIds();
      });
    }
  }

  ngOnInit() { 
    this.getData()
  }

  addOutsourceAgency() {
    this.router.navigateByUrl("home/add-outsourceAgency")
  }

  editOutsourcedAgency(employee) {
    // this.router.navigateByUrl("home/employees/edit-employee")
    this.router.navigate(["home/edit-outsourceAgency", employee.id])

    // if (this.authService.getAccessLevel() == AccessLevels.superAdmin) {
    //   this.router.navigate(["home/employees/edit-employee", employee.id])
    // } else {
    //   this.router.navigate(["home/employees/edit-employee", employee.id])
    // }
  }

  uploadEmployees() { }

  getEmployees() {
    if (this.authService.getAccessLevel() == AccessLevels.superAdmin) {
      this.employeeService.getOutsourceEmployees().subscribe(employees => {
        this.spinner.hide();
        this.allOusourcedEmployees = employees['result'] as [];
      });
    }
  }

  getEmployeesByStationIds() {
    this.employeeService.getEmployeesByStationId(this.stationsList).subscribe(data => {
      this.spinner.hide();
      if (data['result'] != null) {
        this.allOusourcedEmployees = data['result'] as [];
        this.allOusourcedEmployees = this.allOusourcedEmployees.reverse();
      }
    });
  }

  calculateActiveEmployees(employees) {
    let activeCount = 0
    employees.forEach(emp => {
      if (emp.active) {
        activeCount++
      }
    });
    return activeCount
  }

  calculateInActiveEmployees(employees) {
    let inactiveCount = 0
    employees.forEach(emp => {
      if (!emp.active) {
        inactiveCount++
      }
    });
    return inactiveCount
  }

  getAllStations() {
    this.stationService.getOutsourceStations().subscribe(stations => {
      this.stationsList = stations['result'];
    })
  }


  getAvailableSlots(employee) {
    this.spinner.show()
    this.agentScheduleService.getSchedulesByUserId(employee.id).subscribe(availableSlots => {
      this.spinner.hide()
      if (availableSlots['status']) {
        if (availableSlots['result'].length != 0) {
          let slots = availableSlots['result'] as []
          const initialState = {
            dialogData: { "employeeName": employee.firstname + ' ' + employee.lastname, "slots": slots.reverse() },
          };
          const modalRef = this.modalService.show(AgentSlotsCalenderComponent, { initialState });
          modalRef.setClass('modal-lg');
        } else {
          this.notifier.notify('warning', 'No schedules found!')
        }
      }
    })
  }

}
